export enum UploadFileErrorMessage {
  UPLOAD_FILE = 'UPLOAD_FILE'
}

export type UploadFileResponse = {
  success: boolean;
  message: UploadFileErrorMessage | '';
  error: boolean;
};

export enum ErrMessages {
  UPLOAD = 'Column data/headers are incorrect! Please check sample file',
  DEFAULT_MESSAGE = 'Something went wrong while processing the file. Please try again'
}

export type Message = {
  error: boolean;
  success: boolean;
  message: ErrMessages | '';
};
